import React, { useEffect, useState } from "react";
import MaterialTable from 'material-table';
import { useForm } from 'react-hook-form';
import Select from 'react-select'

// reactstrap components
import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    Form,
    Row,
    Col,
    Input,
    Button,
    FormGroup
} from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";
import { InputDIAMES } from "../../services/mask.js";
import { isValidDayMonth } from "../../helpers/valid.js";

import { useAuth } from "context/auth.js";

export default function CadastroDiasNaoUteis({ history }) {
    const { session, setLoading } = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });
    const [permiteEditar, set_permiteEditar] = useState(false);

    const [status, set_status] = React.useState("");
    const [options_status] = React.useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" },
    ]);
    const handleStatus = (value) => {
        set_status(value);
        setValue("status", value, true);
        clearErrors("status");
    }

    const [diaMes, set_diaMes] = useState(null);
    const handleChangeDiaMes = (event) => {
        set_diaMes(event.target.value);
        clearErrors("diaMes");
    }

    const [rowEdit, set_rowEdit] = useState(null);
    const [openCollapse, set_openCollapse] = useState(false);
    const [list_table, set_list_table] = useState([]);

    const loadList = () => {
        set_openCollapse(false);
        set_rowEdit(null);
        setLoading(true);
        api_GET('DiaNaoUtil')
            .then(result => set_list_table(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleAdd = () => {
        set_rowEdit(null);
        set_diaMes("");
        setValue("diaMes", "", false);
        setValue("descricao", "");
        setValue("status", "", false);
        set_status("");
        set_openCollapse(true);
    }

    const handleEdit = (rowData) => {
        clearErrors();
        set_rowEdit(rowData);
        set_diaMes(rowData.diaMes);
        setValue("diaMes", rowData.diaMes, true);
        setValue("descricao", rowData.descricao);
        setValue("status", rowData.status, true);
        set_status(rowData.status)
        set_openCollapse(true);
    }

    const onSubmit = (data) => {
        let diaNaoUtil_Id = rowEdit ? rowEdit.diaNaoUtil_Id : 0;
        if (list_table.filter(f => f.diaMes == diaMes && f.diaNaoUtil_Id != diaNaoUtil_Id).length > 0) {
            showMessage("Aviso", "Este dia/mês já está configurado. Edite a configuração!", 'error', null, null);
            return;
        }

        if (!isValidDayMonth(data.diaMes)) {
            showMessage("Aviso", "Dia/Mês inválido!", 'error', null, null);
            return;
        }

        let json_submit = {
            diaNaoUtil_Id: diaNaoUtil_Id,
            diaMes: diaMes,
            descricao: data.descricao,
            status: status,
            usuarioCadastro_Id: session.usuario_Id,
            usuarioUltimaAlteracao_Id: session.usuario_Id
        }
        setLoading(true);
        if (json_submit.diaNaoUtil_Id == 0) {
            api_POST('DiaNaoUtil', json_submit)
                .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList() }))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_PUT('DiaNaoUtil', json_submit)
                .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList() }))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("CadastroDiasNaoUteis.Editar", function (result) { set_permiteEditar(result) });
        loadList();
    }, []);


    return (
        <>
            <div className="content">
                <button type="button" disabled={!permiteEditar} onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Novo Dia</button>
                <Collapse isOpen={openCollapse} defaultOpen={false}>
                    <Row>
                        <Col md="12">
                            <Card className="card-user">
                                <CardHeader>
                                    <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                                </CardHeader>
                                <CardBody style={{ minHeight: "auto" }}>
                                    <Form style={{ maxWidth: "95%", margin: "0 auto" }} onSubmit={handleSubmit(onSubmit)}>
                                        <Row>
                                            <Col md="5" sm="4">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Descrição</label></b>
                                                    <Input type="text" name="descricao" maxLength={100} innerRef={register({ required: true })} />
                                                    {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col md="4" sm="12">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Dia/Mês</label></b>
                                                    <InputDIAMES value={diaMes} onChange={handleChangeDiaMes} name="diaMes" inputRef={register({ required: true })} />
                                                    {errors.diaMes && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col md="3" sm="12">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Status</label></b>
                                                    <Select
                                                        options={options_status}
                                                        name="status"
                                                        getOptionLabel={({ label }) => label}
                                                        getOptionValue={({ value }) => value}
                                                        onChange={(e) => { handleStatus(e.value) }}
                                                        value={status != "" && options_status.find(obj => obj.value === status)}
                                                        placeholder="Selecione"
                                                        ref={e => register(
                                                            { name: "status" },
                                                            { required: true })
                                                        }
                                                    />
                                                    {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col className="text-center" md="12" sm="12">
                                                <FormGroup>
                                                    <Button color="success" disabled={!permiteEditar} type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Collapse>
                <Row>
                    <Col md="12">
                        <MaterialTable style={{ minHeight: "auto" }}
                            title=""
                            columns={[
                                { title: 'Dia/Mês', field: 'diaMes' },
                                { title: 'Descrição', field: 'descricao' },
                                { title: 'Status', field: 'status' }
                            ]}
                            data={list_table}
                            isLoading={false}
                            options={{
                                ...table_style,
                                filtering: false,
                                exportButton: true
                            }}
                            actions={[
                                {
                                    icon: 'edit',
                                    tooltip: 'Editar Registro',
                                    onClick: (event, rowData) => handleEdit(rowData)
                                }
                            ]}
                            localization={table_translate}
                        />
                    </Col>
                </Row>
            </div>
        </>
    );

}
